// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
  padding: 0px !important;
  max-height: 90vh;
  overflow-y: auto;
}

.box.qrcode-dialog {
  width: 100% !important;
  max-width: 500px;
  min-width: 320px;
  margin: 16px auto;
  padding: 0;
  background: #fff;
  position: relative;
  display: flex;
  flex-direction: column;
  box-shadow: 0 35px 70px rgba(7, 8, 10, 0.35);
  border-radius: 22px;
  overflow: hidden;
}

.box {
  max-width: 500px;
  width: 100% !important;
  margin: 16px auto;
  padding: 0;
  background: #fff;
  background-size: 50%;
  background-position: top center;
  position: relative;
  display: flex;
  flex-direction: column;
  box-shadow: 0 35px 70px rgba(7, 8, 10, 0.35);
  overflow: hidden;
  background-size: cover;
  background-position: center;
  border-radius: 22px;
  background-repeat: no-repeat !important;
  background-size: contain !important;
  background-size: 100% 90%;
  background-position: top center;
}

.dialog-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid #e0e0e0;
  background: #ffffff;
  position: relative;
  z-index: 2;
}

.dialog-content {
  padding: 24px;
}

.box-wrap {
  position: relative;
  z-index: 2;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  padding: 30px 0px;
  display: flex;
  flex-wrap: wrap;
}

.box:after {
  content: "";
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0px;
  left: 0px;
  z-index: 1;
  background: rgba(0, 0, 0, 0.5);
}

.with-icon {
  text-align: left;
  height: 35px !important;
}
.with-icon img {
  margin: 0px !important;
}

.des-box {
  background: #fff;
  position: relative;
  width: 100%;
  padding: 20px 24px;
}
.des-box > div > div mat-card {
  background: #fff !important;
  box-shadow: none !important;
}
.des-box i {
  color: #212427 !important;
}

.des-box:after {
  content: "";
  width: 200%;
  height: 150vh;
  background: #fff;
  border-radius: 0px !important;
  position: absolute;
  top: -100px;
  z-index: -1;
  left: -50%;
  right: -50%;
}

.des-box:before {
  content: "";
  width: 140%;
  height: 38vh;
  background: #fff;
  border-radius: 100% 100% 0px 0px;
  position: absolute;
  top: -16px;
  z-index: -1;
  left: -20%;
  right: -20%;
}

.title-box {
  padding: 0px 0px 60px 0px;
  width: 100%;
}

.title-div {
  border-bottom: 1px solid #e0e0e0;
}

.title-box h2,
.popuptitle {
  color: #212427 !important;
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 20px;
  text-align: left;
  flex: 1;
  padding-right: 48px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.title-box ul {
  margin: 0px;
  padding: 0px;
}

.title-box ul li {
  color: #fff;
  list-style: none;
  padding: 8px 10px 8px 0px;
  font-size: 16px;
  text-align: left;
}

.title-box ul li span {
  margin-right: 8px;
}

.footer-div {
  border-top: 1px solid gray;
  display: flex;
  justify-content: space-between;
}

.footer-div p {
  margin-top: 10px;
  margin-bottom: 0px;
}

p,
h5 {
  color: #212427 !important;
  text-align: left;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

h5 {
  font-size: 16px;
  font-weight: bold;
  margin-top: 0px;
  margin-bottom: 10px;
}

.close-ico,
.close-button {
  position: absolute;
  top: 12px;
  right: 12px;
  color: #666;
  opacity: 1 !important;
  z-index: 20;
  cursor: pointer;
}
.close-ico mat-icon,
.close-button mat-icon {
  color: #666;
}

.close-ico .close-icon {
  font-size: 24px;
  color: #666;
}

.code-div {
  height: 200px;
  overflow-y: scroll;
}

.input-container {
  position: relative;
  display: flex;
  height: 2.8rem;
  width: 100%;
  background-color: #fff;
  border-radius: 8px;
  margin-top: 10px;
  box-shadow: 20px 20px 30px rgba(0, 0, 0, 0.05);
}

.input-container input {
  height: 100%;
  width: 100%;
  border-radius: 8px;
  border: 1px solid rgb(176, 190, 197);
  background-color: transparent;
  padding: 0.625rem 70px 0.625rem 0.75rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 400;
  color: rgb(69, 90, 100);
  outline: none;
  transition: all 0.15s cubic-bezier(0.4, 0, 0.2, 1);
}

.input-container input:focus {
  border-color: #5ea1d8;
}

.invite-btn {
  position: absolute;
  cursor: pointer;
  right: 4px;
  top: 4px;
  bottom: 4px;
  z-index: 10;
  border-radius: 4px;
  background-color: #5ea1d8;
  color: white;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  text-align: center;
  vertical-align: middle;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  border: none;
}

.invite-btn:hover {
  right: 2px;
  top: 2px;
  bottom: 2px;
  border-radius: 8px;
}

.input-container input:placeholder-shown ~ .invite-btn {
  pointer-events: none;
  background-color: #5ea1d8;
  opacity: 0.5;
}

form {
  display: flex;
  align-items: center;
}
form input {
  background-color: #f6f6f6;
  border: none;
  color: #0d0d0d;
  padding: 15px 32px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  margin: 5px;
  width: 85%;
  border: 2px solid #f6f6f6;
  transition: all 0.5s ease-in-out;
  border-radius: 5px;
  outline: none !important;
  border: 0.5px solid lightgrey;
}

.parent-comment-box {
  background: #f3f1f1 !important;
  padding: 10px;
  max-height: 400px;
  overflow-y: scroll;
}

.des-box > div > div mat-card.mat-mdc-card.mdc-card.example-card.child-comment {
  background: #f8f8f8 !important;
  margin-left: 40px;
  margin-top: 10px;
}
.des-box > div > div mat-card.mat-mdc-card.mdc-card.example-card.child-comment mat-card {
  padding: 10px;
}

@media (max-width: 767px) {
  p {
    flex-wrap: wrap;
  }
}
ul + div {
  display: flex;
  align-items: end;
}
ul + div .priceIcon-p {
  bottom: 20px;
  top: unset !important;
}

/* QR code responsive sizing */
qr-code,
#qrCodeImage {
  display: inline-block;
  max-width: 100%;
}

#qrCodeImage canvas {
  width: 100% !important;
  height: auto !important;
  max-width: 320px;
  image-rendering: pixelated;
}

/* Title row responsiveness (likes/views vs price) */
.title-box > div {
  flex-wrap: wrap;
  gap: 8px 12px;
}

/* Responsive breakpoints */
@media (max-width: 640px) {
  .box,
  .box.qrcode-dialog {
    max-width: 100%;
    min-width: auto;
    margin: 8px;
    border-radius: 16px;
    padding: 0;
  }
  .dialog-header {
    padding: 16px;
  }
  .dialog-content {
    padding: 16px;
  }
  .des-box {
    padding: 16px;
  }
  .box-wrap {
    padding: 20px 0px;
  }
  .title-box h2,
  .popuptitle {
    font-size: 18px;
  }
  .title-box ul li {
    font-size: 14px;
  }
  .title-box > div {
    flex-direction: column !important;
    align-items: flex-start !important;
  }
  ul + div .priceIcon-p {
    bottom: auto;
  }
  .close-ico,
  .close-button {
    top: 8px;
    right: 8px;
  }
  .close-ico .close-icon {
    font-size: 24px;
  }
  .des-box:before,
  .des-box:after {
    width: 100%;
    left: 0;
    right: 0;
  }
  #qrCodeImage canvas {
    max-width: 86vw;
  }
}
@media (max-width: 480px) {
  .box,
  .box.qrcode-dialog {
    max-width: calc(100vw - 16px);
    margin: 8px;
    border-radius: 16px;
  }
  .title-box h2,
  .popuptitle {
    font-size: 16px;
    padding-right: 40px;
  }
}
@media (min-width: 768px) {
  .box,
  .box.qrcode-dialog {
    max-width: 500px;
  }
  #qrCodeImage canvas {
    max-width: 360px;
  }
}
@media (min-width: 1024px) {
  .box,
  .box.qrcode-dialog {
    max-width: 500px;
  }
  #qrCodeImage canvas {
    max-width: 400px;
  }
}
.qrcode-heading {
  font-size: 20px !important;
  font-weight: bold !important;
  justify-content: center;
  margin-top: -10px !important;
}

.download-link {
  margin-top: 10px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  outline: none !important;
  color: #212427;
}

:host-context(body.theme-dark) .des-box,
:host-context(body.theme-dark) .des-box:before,
:host-context(body.theme-dark) .des-box:after {
  background: #111827 !important;
  color: #e2e8f0 !important;
  border-color: rgba(148, 163, 184, 0.3) !important;
}
:host-context(body.theme-dark) .qrcode-heading,
:host-context(body.theme-dark) .title-box h2,
:host-context(body.theme-dark) .popuptitle,
:host-context(body.theme-dark) p,
:host-context(body.theme-dark) h5,
:host-context(body.theme-dark) span,
:host-context(body.theme-dark) label,
:host-context(body.theme-dark) small,
:host-context(body.theme-dark) .download-link,
:host-context(body.theme-dark) .close-ico,
:host-context(body.theme-dark) .close-button,
:host-context(body.theme-dark) .close-ico .close-icon,
:host-context(body.theme-dark) .close-button mat-icon,
:host-context(body.theme-dark) .des-box i {
  color: #e2e8f0 !important;
}
:host-context(body.theme-dark) .input-container {
  background-color: #1f2937 !important;
}
:host-context(body.theme-dark) .input-container input,
:host-context(body.theme-dark) form input {
  background-color: #1f2937 !important;
  color: #f8fafc !important;
  border-color: rgba(148, 163, 184, 0.45) !important;
}
:host-context(body.theme-dark) .parent-comment-box,
:host-context(body.theme-dark) .des-box > div > div mat-card.mat-mdc-card.mdc-card.example-card.child-comment {
  background: #0f172a !important;
}

/* Keep bundle QR popup visually aligned with view-flow QR popup. */
.box,
.box.qrcode-dialog {
  max-width: 360px !important;
}

.close-ico,
.close-button {
  color: #ffffff !important;
}
.close-ico mat-icon,
.close-ico .close-icon,
.close-button mat-icon,
.close-button .close-icon {
  color: #ffffff !important;
}

@media (min-width: 768px) {
  .box,
  .box.qrcode-dialog {
    max-width: 360px !important;
  }
}
@media (min-width: 1024px) {
  .box,
  .box.qrcode-dialog {
    max-width: 360px !important;
  }
}
/* Hard-align bundle QR popup shell with viewflow QR popup. */
.box,
.box.qrcode-dialog {
  margin: 0px auto !important;
  padding: 0px 25px !important;
  border-radius: 15px 15px 0px 0px !important;
  box-shadow: 0 5px 11px 0 rgba(0, 0, 0, 0.18), 0 4px 15px 0 rgba(0, 0, 0, 0.15) !important;
}

.container .box {
  width: 100% !important;
  min-height: 250px !important;
  border-radius: 8px !important;
}

.des-box {
  padding: 0 !important;
}

.des-box:after {
  top: 0px !important;
  height: 150vh !important;
  border-radius: 0px !important;
}

.des-box:before {
  width: 200% !important;
  height: 40vh !important;
  top: -34px !important;
  left: -50% !important;
  right: -50% !important;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/bundleqrcode/bundleqrcode.component.scss"],"names":[],"mappings":"AAAA;EACE,uBAAA;EACA,gBAAA;EACA,gBAAA;AACF;;AAEA;EACE,sBAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,UAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,4CAAA;EACA,mBAAA;EACA,gBAAA;AACF;;AAEA;EACE,gBAAA;EACA,sBAAA;EACA,iBAAA;EACA,UAAA;EACA,gBAAA;EACA,oBAAA;EACA,+BAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,4CAAA;EACA,gBAAA;EACA,sBAAA;EACA,2BAAA;EACA,mBAAA;EACA,uCAAA;EACA,mCAAA;EACA,yBAAA;EACA,+BAAA;AACF;;AAEA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,gCAAA;EACA,mBAAA;EACA,kBAAA;EACA,UAAA;AACF;;AAEA;EACE,aAAA;AACF;;AAEA;EACE,kBAAA;EACA,UAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,aAAA;EACA,eAAA;AACF;;AAEA;EACE,WAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,8BAAA;AACF;;AACA;EACE,gBAAA;EACA,uBAAA;AAEF;AADE;EACE,sBAAA;AAGJ;;AACA;EACE,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,kBAAA;AAEF;AAEM;EACE,2BAAA;EACA,2BAAA;AAAR;AAKE;EACE,yBAAA;AAHJ;;AAOA;EACE,WAAA;EACA,WAAA;EACA,aAAA;EACA,gBAAA;EACA,6BAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;AAJF;;AAOA;EACE,WAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,gCAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;AAJF;;AAOA;EACE,yBAAA;EACA,WAAA;AAJF;;AAOA;EACE,gCAAA;AAJF;;AAOA;;EAEE,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,OAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAJF;;AAMA;EACE,WAAA;EACA,YAAA;AAHF;;AAKA;EACE,WAAA;EACA,gBAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;AAFF;;AAIA;EACE,iBAAA;AADF;;AAIA;EACE,0BAAA;EACA,aAAA;EACA,8BAAA;AADF;;AAGA;EACE,gBAAA;EACA,kBAAA;AAAF;;AAGA;;EAEE,yBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AAAF;;AAEA;EACE,eAAA;EACA,iBAAA;EACA,eAAA;EACA,mBAAA;AACF;;AACA;;EAEE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,qBAAA;EACA,WAAA;EACA,eAAA;AAEF;AAAE;;EACE,WAAA;AAGJ;;AACA;EACE,eAAA;EACA,WAAA;AAEF;;AACA;EACE,aAAA;EACA,kBAAA;AAEF;;AACA;EACE,kBAAA;EACA,aAAA;EACA,cAAA;EACA,WAAA;EAGA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,8CAAA;AAAF;;AAGA;EACE,YAAA;EACA,WAAA;EACA,kBAAA;EACA,oCAAA;EACA,6BAAA;EACA,uCAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;EACA,uBAAA;EACA,aAAA;EACA,kDAAA;AAAF;;AAGA;EACE,qBAAA;AAAF;;AAGA;EACE,kBAAA;EACA,eAAA;EACA,UAAA;EACA,QAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,YAAA;EACA,oBAAA;EACA,uBAAA;EACA,oBAAA;EACA,qBAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,YAAA;AAAF;;AAIA;EACE,UAAA;EACA,QAAA;EACA,WAAA;EACA,kBAAA;AADF;;AAIA;EACE,oBAAA;EACA,yBAAA;EACA,YAAA;AADF;;AAGA;EACE,aAAA;EACA,mBAAA;AAAF;AACE;EACE,yBAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;EACA,qBAAA;EACA,eAAA;EACA,WAAA;EACA,UAAA;EACA,yBAAA;EACA,gCAAA;EACA,kBAAA;EACA,wBAAA;EACA,6BAAA;AACJ;;AAEA;EACA,8BAAA;EACA,aAAA;EACA,iBAAA;EACA,kBAAA;AACA;;AACA;EACE,8BAAA;EACA,iBAAA;EACA,gBAAA;AAEF;AADE;EACE,aAAA;AAGJ;;AAAA;EACE;IACE,eAAA;EAGF;AACF;AAAA;EACE,aAAA;EACA,gBAAA;AAEF;AADE;EACE,YAAA;EACA,qBAAA;AAGJ;;AACA,8BAAA;AACA;;EAEE,qBAAA;EACA,eAAA;AAEF;;AACA;EACE,sBAAA;EACA,uBAAA;EACA,gBAAA;EACA,0BAAA;AAEF;;AACA,oDAAA;AACA;EACE,eAAA;EACA,aAAA;AAEF;;AACA,2BAAA;AACA;EACE;;IAEE,eAAA;IACA,eAAA;IACA,WAAA;IACA,mBAAA;IACA,UAAA;EAEF;EACA;IACE,aAAA;EACF;EAEA;IACE,aAAA;EAAF;EAGA;IACE,aAAA;EADF;EAIA;IACE,iBAAA;EAFF;EAKA;;IAEE,eAAA;EAHF;EAMA;IACE,eAAA;EAJF;EAOA;IACE,iCAAA;IACA,kCAAA;EALF;EAQA;IACE,YAAA;EANF;EASA;;IAEE,QAAA;IACA,UAAA;EAPF;EAUA;IACE,eAAA;EARF;EAWA;;IAEE,WAAA;IACA,OAAA;IACA,QAAA;EATF;EAYA;IACE,eAAA;EAVF;AACF;AAaA;EACE;;IAEE,6BAAA;IACA,WAAA;IACA,mBAAA;EAXF;EAcA;;IAEE,eAAA;IACA,mBAAA;EAZF;AACF;AAeA;EACE;;IAEE,gBAAA;EAbF;EAgBA;IACE,gBAAA;EAdF;AACF;AAiBA;EACE;;IAEE,gBAAA;EAfF;EAkBA;IACE,gBAAA;EAhBF;AACF;AAmBA;EACE,0BAAA;EACA,4BAAA;EACA,uBAAA;EACA,4BAAA;AAjBF;;AAoBA;EACE,gBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,wBAAA;EACA,cAAA;AAjBF;;AAqBE;;;EAGE,8BAAA;EACA,yBAAA;EACA,iDAAA;AAlBJ;AAqBE;;;;;;;;;;;;;;EAcE,yBAAA;AAnBJ;AAsBE;EACE,oCAAA;AApBJ;AAuBE;;EAEE,oCAAA;EACA,yBAAA;EACA,kDAAA;AArBJ;AAwBE;;EAEE,8BAAA;AAtBJ;;AA0BA,mEAAA;AACA;;EAEE,2BAAA;AAvBF;;AA0BA;;EAEE,yBAAA;AAvBF;AAyBE;;;;EAEE,yBAAA;AArBJ;;AAyBA;EACE;;IAEE,2BAAA;EAtBF;AACF;AAyBA;EACE;;IAEE,2BAAA;EAvBF;AACF;AA0BA,6DAAA;AACA;;EAEE,2BAAA;EACA,4BAAA;EACA,2CAAA;EACA,yFAAA;AAxBF;;AA2BA;EACE,sBAAA;EACA,4BAAA;EACA,6BAAA;AAxBF;;AA2BA;EACE,qBAAA;AAxBF;;AA2BA;EACE,mBAAA;EACA,wBAAA;EACA,6BAAA;AAxBF;;AA2BA;EACE,sBAAA;EACA,uBAAA;EACA,qBAAA;EACA,qBAAA;EACA,sBAAA;AAxBF","sourcesContent":[".container {\n  padding: 0px !important;\n  max-height: 90vh;\n  overflow-y: auto;\n}\n\n.box.qrcode-dialog {\n  width: 100% !important;\n  max-width: 500px;\n  min-width: 320px;\n  margin: 16px auto;\n  padding: 0;\n  background: #fff;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 35px 70px rgba(7, 8, 10, 0.35);\n  border-radius: 22px;\n  overflow: hidden;\n}\n\n.box {\n  max-width: 500px;\n  width: 100% !important;\n  margin: 16px auto;\n  padding: 0;\n  background: #fff;\n  background-size: 50%;\n  background-position: top center;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 35px 70px rgba(7, 8, 10, 0.35);\n  overflow: hidden;\n  background-size: cover;\n  background-position: center;\n  border-radius: 22px;\n  background-repeat: no-repeat !important;\n  background-size: contain !important;\n  background-size: 100% 90%;\n  background-position: top center;\n}\n\n.dialog-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px 24px;\n  border-bottom: 1px solid #e0e0e0;\n  background: #ffffff;\n  position: relative;\n  z-index: 2;\n}\n\n.dialog-content {\n  padding: 24px;\n}\n\n.box-wrap {\n  position: relative;\n  z-index: 2;\n  box-sizing: border-box;\n  width: 100%;\n  height: 100%;\n  padding: 30px 0px;\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.box:after {\n  content: \"\";\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  top: 0px;\n  left: 0px;\n  z-index: 1;\n  background: rgba(0, 0, 0, 0.5);\n}\n.with-icon {\n  text-align: left;\n  height:35px !important;\n  img{\n    margin: 0px !important;\n  }\n}\n\n.des-box {\n  background: #fff;\n  position: relative;\n  width: 100%;\n  padding: 20px 24px;\n\n  & > div {\n    & > div {\n      mat-card {\n        background: #fff !important;\n        box-shadow: none !important;\n      }\n    }\n  }\n\n  i {\n    color: #212427 !important;\n  }\n}\n\n.des-box:after {\n  content: \"\";\n  width: 200%;\n  height: 150vh;\n  background: #fff;\n  border-radius: 0px !important;\n  position: absolute;\n  top: -100px;\n  z-index: -1;\n  left: -50%;\n  right: -50%;\n}\n\n.des-box:before {\n  content: \"\";\n  width: 140%;\n  height: 38vh;\n  background: #fff;\n  border-radius: 100% 100% 0px 0px;\n  position: absolute;\n  top: -16px;\n  z-index: -1;\n  left: -20%;\n  right: -20%;\n}\n\n.title-box {\n  padding: 0px 0px 60px 0px;\n  width: 100%;\n}\n\n.title-div {\n  border-bottom: 1px solid #e0e0e0;\n}\n\n.title-box h2,\n.popuptitle {\n  color: #212427 !important;\n  font-size: 20px;\n  font-weight: 600;\n  margin-bottom: 20px;\n  text-align: left;\n  flex: 1;\n  padding-right: 48px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.title-box ul {\n  margin: 0px;\n  padding: 0px;\n}\n.title-box ul li {\n  color: #fff;\n  list-style: none;\n  padding: 8px 10px 8px 0px;\n  font-size: 16px;\n  text-align: left;\n}\n.title-box ul li span {\n  margin-right: 8px;\n}\n\n.footer-div {\n  border-top: 1px solid gray;\n  display: flex;\n  justify-content: space-between;\n}\n.footer-div p {\n  margin-top: 10px;\n  margin-bottom: 0px;\n}\n\np,\nh5 {\n  color: #212427 !important;\n  text-align: left;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\nh5 {\n  font-size: 16px;\n  font-weight: bold;\n  margin-top: 0px;\n  margin-bottom: 10px;\n}\n.close-ico,\n.close-button {\n  position: absolute;\n  top: 12px;\n  right: 12px;\n  color: #666;\n  opacity: 1 !important;\n  z-index: 20;\n  cursor: pointer;\n\n  mat-icon {\n    color: #666;\n  }\n}\n\n.close-ico .close-icon {\n  font-size: 24px;\n  color: #666;\n}\n\n.code-div {\n  height: 200px;\n  overflow-y: scroll;\n}\n\n.input-container {\n  position: relative;\n  display: flex;\n  height: 2.8rem;\n  width: 100%;\n  // min-width: 200px;\n  // max-width: 250px;\n  background-color: #fff;\n  border-radius: 8px;\n  margin-top: 10px;\n  box-shadow: 20px 20px 30px rgba(0, 0, 0, 0.05);\n}\n\n.input-container input {\n  height: 100%;\n  width: 100%;\n  border-radius: 8px;\n  border: 1px solid rgb(176 190 197);\n  background-color: transparent;\n  padding: 0.625rem 70px 0.625rem 0.75rem;\n  font-size: 0.875rem;\n  line-height: 1.25rem;\n  font-weight: 400;\n  color: rgb(69 90 100);\n  outline: none;\n  transition: all 0.15s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.input-container input:focus {\n  border-color: #5ea1d8;\n}\n\n.invite-btn {\n  position: absolute;\n  cursor: pointer;\n  right: 4px;\n  top: 4px;\n  bottom: 4px;\n  z-index: 10;\n  border-radius: 4px;\n  background-color: #5ea1d8;\n  color: white;\n  padding-top: 0.25rem;\n  padding-bottom: 0.25rem;\n  padding-left: 0.5rem;\n  padding-right: 0.5rem;\n  text-align: center;\n  vertical-align: middle;\n  font-size: 12px;\n  font-weight: 600;\n  text-transform: uppercase;\n  border: none;\n  // transition: .6s ease;\n}\n\n.invite-btn:hover {\n  right: 2px;\n  top: 2px;\n  bottom: 2px;\n  border-radius: 8px;\n}\n\n.input-container input:placeholder-shown ~ .invite-btn {\n  pointer-events: none;\n  background-color: #5ea1d8;\n  opacity: 0.5;\n}\nform {\n  display: flex;\n  align-items: center;\n  input {\n    background-color: #f6f6f6;\n    border: none;\n    color: #0d0d0d;\n    padding: 15px 32px;\n    text-align: center;\n    text-decoration: none;\n    display: inline-block;\n    font-size: 16px;\n    margin: 5px;\n    width: 85%;\n    border: 2px solid #f6f6f6;\n    transition: all 0.5s ease-in-out;\n    border-radius: 5px;\n    outline:none !important;\n    border:.5px solid lightgrey;\n  }\n}\n.parent-comment-box{\nbackground: #f3f1f1 !important;\npadding:10px;\nmax-height:400px;\noverflow-y: scroll;\n}\n.des-box > div > div mat-card.mat-mdc-card.mdc-card.example-card.child-comment{\n  background:#f8f8f8 !important;\n  margin-left:40px;\n  margin-top:10px;\n  mat-card{\n    padding: 10px;\n  }\n}\n@media (max-width: 767px) {\n  p {\n    flex-wrap: wrap;\n  }\n}\n\nul + div {\n  display: flex;\n  align-items: end;\n  .priceIcon-p {\n    bottom: 20px;\n    top: unset !important;\n  }\n}\n\n/* QR code responsive sizing */\nqr-code,\n#qrCodeImage {\n  display: inline-block;\n  max-width: 100%;\n}\n\n#qrCodeImage canvas {\n  width: 100% !important;\n  height: auto !important;\n  max-width: 320px;\n  image-rendering: pixelated;\n}\n\n/* Title row responsiveness (likes/views vs price) */\n.title-box > div {\n  flex-wrap: wrap;\n  gap: 8px 12px;\n}\n\n/* Responsive breakpoints */\n@media (max-width: 640px) {\n  .box,\n  .box.qrcode-dialog {\n    max-width: 100%;\n    min-width: auto;\n    margin: 8px;\n    border-radius: 16px;\n    padding: 0;\n  }\n\n  .dialog-header {\n    padding: 16px;\n  }\n\n  .dialog-content {\n    padding: 16px;\n  }\n\n  .des-box {\n    padding: 16px;\n  }\n\n  .box-wrap {\n    padding: 20px 0px;\n  }\n\n  .title-box h2,\n  .popuptitle {\n    font-size: 18px;\n  }\n\n  .title-box ul li {\n    font-size: 14px;\n  }\n\n  .title-box > div {\n    flex-direction: column !important;\n    align-items: flex-start !important;\n  }\n\n  ul + div .priceIcon-p {\n    bottom: auto;\n  }\n\n  .close-ico,\n  .close-button {\n    top: 8px;\n    right: 8px;\n  }\n\n  .close-ico .close-icon {\n    font-size: 24px;\n  }\n\n  .des-box:before,\n  .des-box:after {\n    width: 100%;\n    left: 0;\n    right: 0;\n  }\n\n  #qrCodeImage canvas {\n    max-width: 86vw;\n  }\n}\n\n@media (max-width: 480px) {\n  .box,\n  .box.qrcode-dialog {\n    max-width: calc(100vw - 16px);\n    margin: 8px;\n    border-radius: 16px;\n  }\n\n  .title-box h2,\n  .popuptitle {\n    font-size: 16px;\n    padding-right: 40px;\n  }\n}\n\n@media (min-width: 768px) {\n  .box,\n  .box.qrcode-dialog {\n    max-width: 500px;\n  }\n\n  #qrCodeImage canvas {\n    max-width: 360px;\n  }\n}\n\n@media (min-width: 1024px) {\n  .box,\n  .box.qrcode-dialog {\n    max-width: 500px;\n  }\n\n  #qrCodeImage canvas {\n    max-width: 400px;\n  }\n}\n\n.qrcode-heading {\n  font-size: 20px !important;\n  font-weight: bold !important;\n  justify-content: center;\n  margin-top: -10px !important;\n}\n\n.download-link {\n  margin-top: 10px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  outline: none !important;\n  color: #212427;\n}\n\n:host-context(body.theme-dark) {\n  .des-box,\n  .des-box:before,\n  .des-box:after {\n    background: #111827 !important;\n    color: #e2e8f0 !important;\n    border-color: rgba(148, 163, 184, 0.3) !important;\n  }\n\n  .qrcode-heading,\n  .title-box h2,\n  .popuptitle,\n  p,\n  h5,\n  span,\n  label,\n  small,\n  .download-link,\n  .close-ico,\n  .close-button,\n  .close-ico .close-icon,\n  .close-button mat-icon,\n  .des-box i {\n    color: #e2e8f0 !important;\n  }\n\n  .input-container {\n    background-color: #1f2937 !important;\n  }\n\n  .input-container input,\n  form input {\n    background-color: #1f2937 !important;\n    color: #f8fafc !important;\n    border-color: rgba(148, 163, 184, 0.45) !important;\n  }\n\n  .parent-comment-box,\n  .des-box > div > div mat-card.mat-mdc-card.mdc-card.example-card.child-comment {\n    background: #0f172a !important;\n  }\n}\n\n/* Keep bundle QR popup visually aligned with view-flow QR popup. */\n.box,\n.box.qrcode-dialog {\n  max-width: 360px !important;\n}\n\n.close-ico,\n.close-button {\n  color: #ffffff !important;\n\n  mat-icon,\n  .close-icon {\n    color: #ffffff !important;\n  }\n}\n\n@media (min-width: 768px) {\n  .box,\n  .box.qrcode-dialog {\n    max-width: 360px !important;\n  }\n}\n\n@media (min-width: 1024px) {\n  .box,\n  .box.qrcode-dialog {\n    max-width: 360px !important;\n  }\n}\n\n/* Hard-align bundle QR popup shell with viewflow QR popup. */\n.box,\n.box.qrcode-dialog {\n  margin: 0px auto !important;\n  padding: 0px 25px !important;\n  border-radius: 15px 15px 0px 0px !important;\n  box-shadow: 0 5px 11px 0 rgb(0 0 0 / 18%), 0 4px 15px 0 rgb(0 0 0 / 15%) !important;\n}\n\n.container .box {\n  width: 100% !important;\n  min-height: 250px !important;\n  border-radius: 8px !important;\n}\n\n.des-box {\n  padding: 0 !important;\n}\n\n.des-box:after {\n  top: 0px !important;\n  height: 150vh !important;\n  border-radius: 0px !important;\n}\n\n.des-box:before {\n  width: 200% !important;\n  height: 40vh !important;\n  top: -34px !important;\n  left: -50% !important;\n  right: -50% !important;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
